import React from "react";

import SupportTownhouse from "./SupportTownhouse";
import SupportVirtual from "./SupportVirtual";
import SupportLearning from "./SupportLearning";
import SupportContact from "./SupportContact";
import SupportTitle from "./Title";
import SupportSubNav from "./SupportSubNav";
import PageLayout from "../policies/PageLayout";

type MainSupportContentProps = {
  slug: string;
};

const navItems = [
  {
    text: "Townhouse",
    href: "townhouse",
  },
  {
    text: "Virtual",
    href: "virtual",
  },
  {
    text: "Accelerate and Elevate",
    href: "learning",
  },
  {
    text: "Contact Us",
    href: "contact-us",
  },
];

const MainSupportContent: React.FunctionComponent<MainSupportContentProps> = (
  props
) => {
  const [slug, setSlug] = React.useState<string>(props.slug || "townhouse");

  React.useEffect(() => {
    setSlug(props.slug);
  }, [props.slug]);

  const slugHandler = (slug: string) => {
    setSlug(slug);
  };

  const getContentHandler = (slug: string) => {
    if (slug === "townhouse") return <SupportTownhouse />;
    if (slug === "virtual") return <SupportVirtual />;
    if (slug === "learning") return <SupportLearning />;
    if (slug === "contact-us") return <SupportContact />;

    return <SupportTownhouse />;
  };

  return (
    <PageLayout>
      <SupportTitle />
      <SupportSubNav
        activeSection={slug}
        navHandler={slugHandler}
        navItems={navItems}
        pageBase="support"
      />

      {getContentHandler(slug)}
    </PageLayout>
  );
};

export default MainSupportContent;
